import { DetaljerState } from './interface';

const getDetaljer = (state: DetaljerState): DetaljerState => state;

const selectors = {
  getDetaljer,
};

export default selectors;
